<template>
  <div class="main-header">
    <div class="container">
      <div class="row no-gutters">
        <div class="col d-flex align-items-center">
          <!-- Logo Desktop -->
          <router-link v-close-menu class="logo mr-3 d-none d-md-block" :to="home"></router-link>

          <!-- Logo Mobile -->
          <router-link v-close-menu class="logo mr-3 d-md-none" :to="home"></router-link>
        </div>
        <div class="col-auto d-none d-md-block">
          <div class="row h-100 align-items-center">
            <router-link v-if="isAdmin" class="col-auto" :active="$route.name === 'investors-list'" :to="{ name: 'investors' }">
              Investitori
            </router-link>
            <router-link v-if="isAdmin" class="col-auto" :active="$route.name === 'consultants-list'" :to="{ name: 'consultants' }">
              Supervisors
            </router-link>
            <router-link v-if="isAdmin || isConsultant" class="col-auto" :active="$route.name === 'companies-list'" :to="{ name: 'companies' }">
              Aziende
            </router-link>
            <AccountDropdown v-if="$oauth2.me" class="col-auto" @action-selected="actionSelected" :active="activeAction" />
          </div>
        </div>
        <Hamburger class="col-auto d-flex align-items-center d-md-none px-4"></Hamburger>
      </div>
    </div>

    <BModal title="Profilo" dialog-class="modal--type-dialog" id="profile-modal" ref="profile-modal" hide-footer centered scrollable>
      <AccountForm :edit="true" :user="user" />
    </BModal>

    <BModal title="Cambia Password" dialog-class="modal--type-dialog" id="change-password-modal" ref="change-password-modal" hide-footer centered scrollable>
      <ProfilePasswordChangeForm />
    </BModal>

    <BModal dialog-class="modal--type-dialog" id="error-modal" ref="error-modal" centered scrollable>
      Si è verificato un errore durante il recupero dell'utente, si prega di riprovare
      <template #modal-footer>
        <button class="ml-2 btn btn-outline-danger" @click="close('error-modal')">Chiudi</button>
      </template>
    </BModal>
  </div>
</template>

<script>

import { BModal } from 'bootstrap-vue';
import closeMenuDirective from '../../../../libs/Sidebar/directives/closeMenu';

export default {
  name: 'layout-header',
  directives: {
    closeMenu: closeMenuDirective,
  },
  components: {
    BModal,
    AccountForm: () => import('../../Account/AccountForm'),
    ProfilePasswordChangeForm: () => import('../../Account/ProfilePasswordChangeForm'),
    AccountDropdown: () => import('../../Account/AccountDropdown'),
    Hamburger: () => import('../../../../libs/Sidebar/components/Hamburger/CssHamburger'),
  },
  data () {
    return {
      user: null,
      activeAction: null,
    };
  },
  computed: {
    isAdmin () {
      return !!this?.$oauth2?.me?.admin;
    },
    isConsultant () {
      return !!this?.$oauth2?.me?.consultant;
    },
    showContextSelect () {
      return this.$oauth2.me && (this.$oauth2.me.companies?.length || 0) > 1;
    },
    home () {
      if (!this.$oauth2.me) {
        return { name: 'login' };
      }

      if (this.$oauth2.me.admin || this.$oauth2.me.consultant) {
        return { name: 'companies-index' };
      } else {
        return { name: 'operative-company', params: { id: this.$appState.context?.id } };
      }
    },
  },
  methods: {
    async actionSelected (name) {
      if (name === 'logout') {
        this.activeAction = 'logout';
        await this.$router.push({ name: 'logout' });

        return;
      }

      if (name === 'profile') {
        this.activeAction = 'profile';

        try {
          const res = await this.$api.getMyProfile();
          this.user = res.data;
          this.$refs['profile-modal'].show();
        } catch (error) {
          this.$refs['error-modal'].show();
        }

        return;
      }

      if (name === 'changePassword') {
        this.activeAction = 'changePassword';
        this.$refs['change-password-modal'].show();
      }
    },
    close (ref) {
      this.$refs[ref].hide();
      this.activeAction = 'null';
    },
  },
};

</script>

<style lang="scss">

$main-header-background-color: #999 !default;
$main-header-text-color: #fff !default;
$main-header-border-bottom-color: #777 !default;
$main-header-box-shadow-color: #2c2c2c !default;
$main-header-height-mobile: 60px !default;
$main-header-height-tablet: 87px !default;
$main-header-height-desktop: $main-header-height-tablet !default;

.management-layout {
  .main-header {
    flex-shrink: 0;
    align-items: center;
    background-color: $main-header-background-color;
    box-shadow: 0px 3px 6px rgba($main-header-box-shadow-color, .11);
    color: $main-header-text-color;
    display: flex;
    font-weight: bold;
    height: $main-header-height-mobile;
    padding: 5px 0;
    position: sticky;
    top: 0;
    z-index: 999;

    @include media-breakpoint-up("md") {
      height: $main-header-height-tablet;
      padding: 8px 0;
    }

    @include media-breakpoint-up("lg") {
      height: $main-header-height-desktop;
    }

    &>.container {
      padding-right: 0;

      @include media-breakpoint-up("md") {
        padding-right: 15px;
      }
    }

    .logo {
      display: inline-block;
      height: 50px;
      width: 50px;
      background: url($path-images + '/logotype-no-mark.png') no-repeat center left;
      background-size: contain;

      @include media-breakpoint-up("md") {
        background-image: url($path-images + '/logo-horizontal.png');
        width: 150px;
      }
    }
  }
}

.modal-header {
  .close {
    background: none;
    border: none;
    box-shadow: none;
  }
}

.modal-backdrop {
  opacity: 0.5;
}

</style>
